module.exports = __webpack_public_path__ + "static/media/bfile-employed.f9ad2734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-employed.svg
// module id = 3102
// module chunks = 0